import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.starts-with.js";
import "core-js/modules/web.dom-collections.for-each.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import useSearchParameter from 'hooks/useSearchParameter';
import { useCurrentScreenContexts } from 'hooks/useCurrentScreenContexts';
import useFetchUserAnalysis from 'actions/users/useFetchUserAnalysis';
import { getAgentElement } from '../getAgentElement';
import { setLastFullContext } from './lastFullContext';
import { pushSituationalAwareness } from './pushSituationalAwareness';
import { useExtraSituationalAwarenessContext } from './useExtraSituationalAwarenessContext';
import { useFetchFormattedCalendarData } from './useFetchFormattedCalendarData';
import { useFetchUserProfile } from 'actions/userProfile';

// Keeps the agent's situational awareness continuously up to date: route,
// on-screen context, calendar settings, user profile, meeting-analysis
// availability, and the extra context contributed by other surfaces/features
// (see useExtraSituationalAwarenessContext).
// Re-pushes to the agent element via setSituationalAwareness whenever any of these change.
export function useMindsetSituationalAwareness(isInitialized, containerId,
// Bumped by callers whose agent element can be replaced after initialization
// (see useMindsetCardAgent's renderGeneration) so this effect re-syncs on that
// swap too, not just on the initial isInitialized flip.
resyncKey) {
  var _userAnalysis$userMee;
  var _useLocation = useLocation(),
    pathname = _useLocation.pathname;
  var _useSearchParameter = useSearchParameter('q'),
    _useSearchParameter2 = _slicedToArray(_useSearchParameter, 1),
    q = _useSearchParameter2[0];
  var screenContexts = useCurrentScreenContexts();
  var extraContext = useExtraSituationalAwarenessContext();

  // Fetch the latest user analysis to determine if we have meeting analysis available
  var _useFetchUserAnalysis = useFetchUserAnalysis({}),
    userAnalysis = _useFetchUserAnalysis.data,
    isLoadingUserAnalysis = _useFetchUserAnalysis.isLoading;
  var hasMeetingAnalysis = Boolean(userAnalysis === null || userAnalysis === void 0 || (_userAnalysis$userMee = userAnalysis.userMeetings) === null || _userAnalysis$userMee === void 0 ? void 0 : _userAnalysis$userMee.length);
  var _useFetchUserProfile = useFetchUserProfile(),
    userProfile = _useFetchUserProfile.data;
  var calendarSettings = useFetchFormattedCalendarData();
  useEffect(function () {
    if (!isInitialized) return;
    var agentEl = getAgentElement(containerId);
    if (!(agentEl !== null && agentEl !== void 0 && agentEl.setSituationalAwareness)) return;
    var context = _objectSpread({
      currentRoute: pathname,
      // What is visible on the user's screen right now, as registered
      // via useVisibleScreenContext
      screenContext: JSON.stringify(screenContexts),
      calendarSettings: JSON.stringify(calendarSettings !== null && calendarSettings !== void 0 ? calendarSettings : null),
      userProfile: JSON.stringify(userProfile !== null && userProfile !== void 0 ? userProfile : null)
    }, extraContext);
    if (!isLoadingUserAnalysis) {
      context.hasMeetingAnalysis = String(hasMeetingAnalysis);
    }
    if (pathname.startsWith('/search') && q) {
      context.searchQuery = q;
    }

    // Recorded only once the SDK has accepted it, so a payload it rejects as
    // oversized cannot become the base every later direct sync merges onto.
    // The agent keeps the context it already had, which beats letting the
    // rejection escape this effect and take the page down with it.
    if (pushSituationalAwareness(agentEl, context)) {
      setLastFullContext(context);
    }
  }, [pathname, q, isInitialized, containerId, resyncKey, extraContext, screenContexts, hasMeetingAnalysis, isLoadingUserAnalysis, calendarSettings, userProfile]);
}